<e-dialog [open]="open()" (openChange)="onOpenChange($event)" [title]="text().title" size="md">
  <ng-template>
    <div class="shared-list">
      @if (error()) {
        <div class="shared-error">{{ error() }}</div>
      }
      @if (loading()) {
        <div class="shared-empty">{{ text().loading }}</div>
      } @else if (items().length === 0) {
        <div class="shared-empty">{{ text().empty }}</div>
      } @else {
        @for (item of items(); track item.id) {
          <div class="shared-row" data-test-id="shared-list-row">
            <i class="fas fa-share-nodes shared-icon" aria-hidden="true"></i>
            <button type="button" class="shared-name" [title]="item.name" (click)="openChart(item)">{{ item.name }}</button>
            <span class="shared-date">{{ formatSharedOn(item.sharedOn) }}</span>
            <button
              eBtn
              size="sm"
              color="highlight"
              icon="copy"
              iconColor="primary-75"
              [tooltip]="text().copyLink"
              [disabled]="stoppingAll()"
              (click)="copyLink(item)"
            ></button>
            <button
              eBtn
              size="sm"
              color="highlight"
              icon="link-slash"
              iconColor="danger"
              [tooltip]="text().stop"
              [disabled]="stoppingAll()"
              (click)="stop(item)"
              data-test-id="shared-list-stop"
            ></button>
          </div>
        }
      }
      @if (!loading() && items().length > 1) {
        <div class="shared-actions">
          <button
            eBtn
            color="highlight"
            icon="link-slash"
            iconColor="danger"
            [disabled]="stoppingAll()"
            (click)="stopAll()"
            data-test-id="shared-list-stop-all"
          >{{ text().stopAll }}</button>
        </div>
      }
    </div>
  </ng-template>
</e-dialog>
